import {
  Box, DashboardModule, DashboardModuleListItem, Form,
} from '@domain-group/suit-theme'

import { UseFormPayload } from '@domain-group/react-hooks'

interface EmailSettingsProps {
  formPayload : UseFormPayload,
}

const EmailSettings = (props: EmailSettingsProps) => {
  const { formPayload } = props
  const {
    entityState: {
      options: {
        order_confirmation_send_to_agency_email, order_confirmation_custom_agency_emails,
      },
    },
    handlers,
  } = formPayload

  return (
    <DashboardModule contentBoxProps={{ border: 'none', flexDirection: 'column' }} title="Emails">
      <DashboardModuleListItem
        showCheckbox
        isChecked={order_confirmation_send_to_agency_email !== 'no'}
        title="Confirmation emails sent to agency"
        secondaryText="Add who should receive order and artwork confirmation emails"
        boxProps={{ border: 'none' }}
      >
        <Form.Field>
          {/*
           // @ts-expect-error TS2322 */}
          <select
            data-value-type="text"
            name="options.order_confirmation_send_to_agency_email"
            value={order_confirmation_send_to_agency_email}
            {...handlers}
          >
            <option value="yes">Yes (Default)</option>
            <option value="no">No</option>
            <option value="custom">Custom email(s)</option>
          </select>
        </Form.Field>
      </DashboardModuleListItem>

      {order_confirmation_send_to_agency_email === 'custom' && (
      <Box alignItems="center" padding="large" paddingTop="0" gridGap="medium">
        <Box overflow="hidden" justifyContent="flex-end">
          <Form.Field>
            <input
              data-value-type="text"
              name="options.order_confirmation_custom_agency_emails"
              type="text"
              placeholder="Add emails, separated by commas"
              value={order_confirmation_custom_agency_emails || ''}
              {...handlers}
            />
          </Form.Field>
        </Box>
      </Box>
      )}
    </DashboardModule>
  )
}

export default EmailSettings
